"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _menu = require("../utils/menu");

var _wujiApi = _interopRequireDefault(require("../wujiApi"));

var _lodash = require("lodash");

var _common = require("../utils/common");

var _constant = require("../constant");

/**
 * 多数源的数据操作基类
 * 1. table schema尚未存储
 */
var Requester = /*#__PURE__*/function () {
  function Requester(_ref, uuid) {
    var tableTree = _ref.tableTree,
        rawTableList = _ref.rawTableList;
    (0, _classCallCheck2["default"])(this, Requester);
    this.tableTree = tableTree;
    this.rawTableList = rawTableList;
    this.errMsg = [];
    this.wujiApi = new _wujiApi["default"]({
      errMsg: this.errMsg,
      uuid: uuid
    });
  } // ----------------------------------------------------------------------

  /**
   * 基于table树所有节点的数据，构造出从主表开始的数据树
   */


  (0, _createClass2["default"])(Requester, [{
    key: "buildDataTreeByTableTree",
    value: function buildDataTreeByTableTree() {
      var _this = this;

      var that = this;
      var mainDataList = (0, _lodash.cloneDeep)(this.tableTree.dataList);
      mainDataList.forEach(function (data) {
        that.buildDataTree(data, _this.tableTree);
      });
      return mainDataList;
    }
    /**
     * 补充指定table的一条数据的所有子table的关联数据（递归）
     * @param {*} $data table实例的一条数据
     * @param {*} table table实例
     */

  }, {
    key: "buildDataTree",
    value: function buildDataTree($data, table) {
      var that = this;
      var data = $data;
      var forkTableList = table.forkTableList;

      if (forkTableList.length === 0) {
        return;
      }

      forkTableList.forEach(function (forkTableAndRelation) {
        var forkTable = forkTableAndRelation.forkTable,
            relationObj = forkTableAndRelation.relationObj;
        var relation = relationObj.relation;
        var forkDataList = forkTable.dataList;
        var forkTableKey = "".concat(forkTable.appId).concat(_constant.SPLIT).concat(forkTable.schemaId); // 普通关联的键在子表、普通关联的键在父表

        if (relation[1] === _menu.RelationStatus.RIGHT || relation[1] === _menu.RelationStatus.LEFT) {
          data[forkTableKey] = (0, _lodash.cloneDeep)(forkDataList.filter(function (forkData) {
            return "".concat(data[relation[0]]) === "".concat(forkData[relation[2]]);
          }));
        } // 反向关联link的键在子表


        if (relation[1] === _menu.RelationStatus.IN && data[relation[0]]) {
          data[forkTableKey] = (0, _lodash.cloneDeep)(forkDataList.filter(function (forkData) {
            return forkData[relation[2]].split(_constant.LINKSPLIT).indexOf("".concat(data[relation[0]])) > -1;
          }));
        } // 反向关联link的键在父表


        if (relation[1] === _menu.RelationStatus.INCLUDE && data[relation[0]]) {
          data[forkTableKey] = (0, _lodash.cloneDeep)(forkDataList.filter(function (forkData) {
            if (!forkData[relation[2]]) {
              return false;
            }

            return data[relation[0]].split(_constant.LINKSPLIT).indexOf("".concat(forkData[relation[2]])) > -1;
          }));
        } // 递归调用


        if (data[forkTableKey] && data[forkTableKey].length > 0) {
          data[forkTableKey].forEach(function (childData) {
            that.buildDataTree(childData, forkTable);
          });
        }
      });
    } // ----------------------------------------------------------------------

    /**
     * 基于旧的数据树，还原table树所有节点的数据
     * @param {*} dataList
     * @param {*} table
     */

  }, {
    key: "regainTableTreeByDataTree",
    value: function regainTableTreeByDataTree(dataList, table) {
      var that = this;
      var primaryKey = table.primaryKey;
      dataList.forEach(function (data) {
        // 该条数据的添加要判断一下去重：因为数据树是可能多个父数据引用同一个子数据，已被添加过
        var findData = table.dataList.find(function (oldData) {
          return (0, _common.toString)(oldData[primaryKey]) === (0, _common.toString)(data[primaryKey]);
        });

        if (!findData) {
          table.dataList.push((0, _common.cloneDeepRawData)(data));
        } // 对每条数据的子数据，要处理一下引用的子表数据集


        Object.keys(data).forEach(function (key) {
          // 找出当前table的子table集
          var forkTableArray = table.forkTableList.map(function (item) {
            return item.forkTable;
          }); // 如果符合子数据集的key值，说明是子表数据

          var forkTable = forkTableArray.find(function (item) {
            return "".concat(item.appId).concat(_constant.SPLIT).concat(item.schemaId) === key;
          });

          if (forkTable) {
            if (data[key] && data[key].length > 0) {
              that.regainTableTreeByDataTree(data[key], forkTable);
            }
          }
        });
      });
    }
  }]);
  return Requester;
}();

var _default = Requester;
exports["default"] = _default;